/**
 * 对照原始对象和新对象，如果新对象的某个属性值是 null，而原始对象的对应的是数组，则将新对象的属性值变更为[]
 * @param originalObj 原始对象
 * @param newObj 新对象
 */
// eslint-disable-next-line complexity
export function arrApplyNull(originalObj, newObj): void {
    if (typeof newObj !== 'object' || typeof originalObj !== 'object') {
        return;
    }
    if (newObj === null || originalObj === null) {
        return;
    }
    for (const key in newObj) {
        if (newObj[key] === null && Array.isArray(originalObj[key])) {
            newObj[key] = [];
        } else if (
            typeof newObj[key] === 'object'
            && typeof originalObj[key] === 'object'
            && newObj[key]
            && originalObj[key]
        ) {
            arrApplyNull(originalObj[key], newObj[key]);
        }
    }
}
